export default __webpack_public_path__ + "static/media/backbtn.ee0e9f77.svg";